import { StateCreator } from 'zustand'
import { ErrorDetails } from 'store/error/types'
import { TypesRoutes } from 'routes/mixedRoutes/types'
import { errorHandling } from 'store/utils/provider'
import { defaultError } from 'common/mocks/ResponseError'
import MonitoringService from 'service/MonitoringService'

import { MonitoringState } from './types'

export const createMonitoringSlice: StateCreator<
  MonitoringState,
  [],
  [],
  MonitoringState
> = () => ({
  monitoring: async (payload) => {
    try {
      await MonitoringService.postMonitoring(payload)
    } catch (error) {
      const errorDetails: ErrorDetails = {
        ...defaultError,
        route: TypesRoutes.REQUEST_GO_BACK,
      }

      errorHandling(error as Error, 'MonitoringService/monitoring', errorDetails)
    }
  },
})
